module.exports = __webpack_public_path__ + "media/images/products/banners/small_caps-ae31cc371ec62cb7487bce8fcf20b9af.png";